import { StateCreator } from "zustand";
import {
  DeliveryTypeOptionsIdType,
  DELIVERY_TYPE_OPTIONS,
} from "@shared/constants";
import { UserBasedVenueSerializer } from "@app-contexts/dashboard/features/venues/data/types/user-venue";
import { type Store } from "../useStore";

export type BoxOfficeConfigType = {
  auto_checkin: boolean;
  ticket_delivery: DeliveryTypeOptionsIdType;
  receipt_delivery: DeliveryTypeOptionsIdType;
  payment_type?: number;
  other_custom_type?: number;
  is_delivery_method_selection_required: boolean;
  is_thermal: boolean;
  thermal_template?: UserBasedVenueSerializer["thermal_templates"][number];
  selected_thermal_printer: string;
  selected_receipt_printer: string;
  pinned_events: { [key: string]: string[] };
  pinned_products: string[];
  pinned_memberships: string[];
  is_thermal_receipt?: boolean;
  /** Remember user's Square terminal preference for box office checkout */
  prefers_square_terminal?: boolean;
};

type State = {
  boxOfficeConfig: BoxOfficeConfigType;
};

type Actions = {
  clearBoxOfficeConfig(): void;
  setBoxOfficeConfig(boxOfficeConfig: State["boxOfficeConfig"]): void;
};

export type BoxOfficeConfigSlice = State & Actions;

const boxOfficeConfigInitialState: State["boxOfficeConfig"] = {
  auto_checkin: false,
  receipt_delivery: DELIVERY_TYPE_OPTIONS.TYPE_PRINT.id,
  ticket_delivery: DELIVERY_TYPE_OPTIONS.TYPE_NONE.id,
  is_delivery_method_selection_required: false,
  is_thermal: false,
  thermal_template: undefined,
  selected_thermal_printer: "",
  selected_receipt_printer: "",
  pinned_events: {},
  pinned_products: [],
  pinned_memberships: [],
  prefers_square_terminal: false,
};

const createBoxOfficeConfigSlice: StateCreator<
  Store,
  [["zustand/persist", unknown]],
  [],
  BoxOfficeConfigSlice
> = (set) => ({
  boxOfficeConfig: boxOfficeConfigInitialState,

  setBoxOfficeConfig(boxOfficeConfig) {
    set({ boxOfficeConfig });
  },

  clearBoxOfficeConfig() {
    set({ boxOfficeConfig: boxOfficeConfigInitialState });
  },
});

export default createBoxOfficeConfigSlice;
